import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';

import { assertConfirmOrderSuccess } from './errors';

import type {
  InitiateConfirmationRequest,
  InitiateConfirmationResponse,
  ResendConfirmationRequest,
  ResendConfirmationResponse,
  RespondMerchantConfirmationRequest,
  RespondMerchantConfirmationResponse,
} from '../model';

export class MerchantConfirmationApi {
  initiateConfirmation(
    data: InitiateConfirmationRequest
  ): Promise<InitiateConfirmationResponse> {
    const url = `${config.apiHost}/confirmation/merchant_portal/api/v1/merchant/initiate_confirmation`;
    return makeRequest<ResponseSuccess<InitiateConfirmationResponse>>({
      url,
      credentials: 'include',
      payload: data,
    }).then((response) => response.payload);
  }

  resendOrderConfirmation(
    data: ResendConfirmationRequest
  ): Promise<ResendConfirmationResponse> {
    const url = `${config.apiHost}/confirmation/merchant_portal/api/v1/merchant/resend_order_confirmation`;
    return makeRequest<ResponseSuccess<ResendConfirmationResponse>>({
      url,
      credentials: 'include',
      payload: data,
    }).then((response) => response.payload);
  }

  confirmOrder(
    data: RespondMerchantConfirmationRequest
  ): Promise<RespondMerchantConfirmationResponse> {
    const url = `${config.apiHost}/confirmation/merchant_portal/api/v1/merchant/confirm_order`;
    return makeRequest<ResponseSuccess<RespondMerchantConfirmationResponse>>({
      url,
      credentials: 'include',
      payload: data,
    }).then((response) => assertConfirmOrderSuccess(response.payload));
  }
}

export const merchantConfirmationApi = new MerchantConfirmationApi();
